import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import PlaceIcon from 'material-ui/svg-icons/maps/place';
import { white } from 'material-ui/styles/colors';

const style = require('./GoogleMapStyle.json')

const Pin = ({ text }) => <PlaceIcon style={{transform: "translate(-50%,-50%)"}}/>;

const Map = {
    options: {
        maxZoom: 19,
        disableDefaultUI: true,
        styles: style
    }
}
class GoogleMap extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    }
    static defaultProps = {
        defaultCenter: {
            lat: 59.95,
            lng: 5
        },
        center: null,
        markerText: "Machine",
        zoom: 11
    };

    render() {
        return (
        // Important! Always set the container height explicitly
        <div style={{ height: '400px', width: '100%' }}>
            <GoogleMapReact
            bootstrapURLKeys={{ key: "AIzaSyDmgjfMRR66L5UINGiDTGMsLxXbH-ZBTrQ"  }}
            defaultCenter={this.props.defaultCenter}
            center={this.props.center}
            defaultZoom={this.props.zoom}
            options={Map.options}
            yesIWantToUseGoogleMapApiInternals
            >
            <Pin
                lat={this.props.center.lat}
                lng={this.props.center.lng}
                text={this.props.markerText}
                color='red'
            />
            </GoogleMapReact>
        </div>
        );
    }
}

export default GoogleMap;


/** WEBPACK FOOTER **
 ** ./src/components/GoogleMap.jsx
 **/